import styled, { css } from 'styled-components';
import { Modal } from '@mui/material';
import { motion } from 'framer-motion';

export const StyledDailyBonusModal = styled(Modal)`
  overflow: auto;

  &.modal-preview {
    position: absolute !important;

    .MuiBackdrop-root.MuiModal-backdrop {
      position: absolute !important;
    }

    .daily-bonus-border {
      --banner-width-px: 321px;
      --popup-banner-ratio: 1 / 1;
    }

    .daily-bonus-border {
      --banner-width-px: 342px;
      --popup-banner-ratio: 1 / 1;
    }
  }

  &__preview {
    position: absolute !important;
    overflow: hidden;

    .MuiBackdrop-root.MuiModal-backdrop {
      position: absolute !important;
    }

    .daily-bonus-border {
      --banner-width-px: 342px;
      --popup-banner-ratio: 1 / 1;
    }
  }
`;

export const StyledDailyBonusBorder = styled(motion.div)`
  margin: auto;
  --banner-width-px: 342px;
  width: 100%;
  border-radius: 20px;
  filter: drop-shadow(0 0 40px rgba(0, 0, 0, 0.6));
  max-width: var(--banner-width-px);
  height: 330px;
  background: var(--bundle-border-color);
  padding: 2px;
  box-shadow: 0 2px 4px 0 rgba(255, 255, 255, 0.25) inset,
    0 -1px 2px 0 rgba(0, 0, 0, 0.61) inset;

  &:focus-visible {
    outline: none;
  }

  * {
    box-sizing: border-box;
  }
`;

export const StyledPopup = styled.div`
  :focus-visible {
    outline: none;
  }

  width: 100%;
  height: 100%;

  .daily-bonus-banner {
    font-family: var(--font-family), Arial;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    background-color: transparent;
    border-radius: 18px;
    padding: 15px;
    position: relative;
    width: inherit;
    height: inherit;

    ${(props: any) =>
      props.backgroundImage &&
      css`
        background-image: url(${props.backgroundImage});
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
      `}
    &__close-icon {
      padding: 10px;
      position: absolute;
      top: 0;
      right: 0;
      border: unset;
      background: unset;

      &:hover {
        cursor: pointer;
      }
    }

    &__title {
      font-size: ${(props: any) => props?.titleSize};
      font-weight: ${(props: any) => props?.titleWeight};
      color: ${(props: any) => props?.titleColor};
      margin: 25px 0 0;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 100%;
      text-shadow: 1px 1px 1px #000, -1px -1px 1px #000, 1px -1px 1px #000,
        -1px 1px 1px #000;
    }

    &__action-button {
      min-height: 32px;
      height: 32px;
      font-size: 24px;
      font-weight: 950;
      text-shadow: 1px 1px 1px #000, -1px -1px 1px #000, 1px -1px 1px #000,
        -1px 1px 1px #000;
      border-radius: 20px;
      position: relative;
      z-index: 1;
      overflow: hidden;
      box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25), 0 -2px 1.8px 0 #3e7e0f inset,
        0 1px 1px 0 #a4ee13 inset, 0 2px 1px 0 #edfe33 inset;

      .stroked {
        text-decoration-line: line-through;
        text-decoration-color: #d8232a;
        text-decoration-thickness: 2px;
        display: flex;
        align-items: center;
        font-size: 20px;
      }

      &--disabled {
        cursor: default;
        background: linear-gradient(180deg, #dcdcdc 0%, #7a7a7a 100%);
        box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25),
          0 -2px 1.8px 0 #848484 inset, 0 1px 1px 0 #f2f2f2 inset,
          0 2px 1px 0 #fff inset;

        img {
          margin-right: 5px;
          height: 18px;
        }
      }
    }

    &__product-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: white;
      width: 100%;

      &__product-amount {
        text-shadow: 1px 1px 1px #000, -1px -1px 1px #000, 1px -1px 1px #000,
          -1px 1px 1px #000;
        font-size: 20px;
        font-weight: 950;
      }
    }
  }
` as any;
